import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { EditMonitorFooter } from '@security/monitors/monitor-form/EditMonitorFooter';
import { EditOutlined } from '@ant-design/icons';
import { monitorMenuConfigs } from './monitor-form/MonitorMenu';
import { SonarText } from '@ui/text';
import { When } from 'react-if';
import { Card, Space } from 'antd';
import { MonitorForm } from './monitor-form/MonitorForm';
import React, { useCallback, useEffect, useRef } from 'react';
import { useBoolean, useForm, usePrevious } from '@hooks';
export const MonitorCard = ({ monitor, onCancel, onSave }) => {
    const { form } = useForm({
        required: ['applicationId', 'monitorConfig.monitorTypeId', 'name']
    });
    const ref = useRef(null);
    const previous = usePrevious(monitor);
    const [editing, setEditing] = useBoolean(Boolean(!monitor.id));
    const monitorConfig = monitorMenuConfigs.find((config) => { var _a; return config.type === ((_a = monitor.monitorConfig) === null || _a === void 0 ? void 0 : _a.monitorTypeId); });
    useEffect(() => {
        if (monitor !== previous) {
            form.setFieldsValue(monitor);
        }
    }, [monitor, previous]);
    const getName = useCallback(() => {
        if (!monitor.applicationId || !monitor.name) {
            return COPY_SPECIFIC.CREATE_NEW_MONITOR;
        }
        return editing ? COPY_SPECIFIC.EDITING_LABEL(monitor.name) : monitor.name;
    }, [monitor, editing]);
    const handleCancel = useCallback(() => {
        setEditing.off();
        if (onCancel) {
            onCancel();
        }
        form.reset();
    }, [form, onCancel, setEditing]);
    const handleSave = useCallback(() => {
        var _a;
        (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.save();
        setEditing.off();
        if (onSave) {
            onSave();
        }
    }, [ref, onSave, setEditing]);
    const handleDelete = useCallback(() => {
        var _a;
        setEditing.off();
        (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.delete();
    }, [ref, setEditing]);
    return (React.createElement(Card, { bordered: false, className: classNames('monitor-card', { 'can-edit': !editing }), extra: React.createElement(When, { condition: !editing },
            React.createElement(EditOutlined, { className: 'edit-icon' })), onClick: editing ? undefined : () => setEditing.on(), title: React.createElement(SonarText, { className: 'h3' }, getName()) },
        React.createElement(Space, { className: 'monitor-card-body', direction: 'vertical' },
            React.createElement(MonitorForm, { editing: editing, form: form, hideApplications: true, menuOptions: 'applicationRequired', monitor: monitor, ref: ref }),
            React.createElement(When, { condition: editing },
                React.createElement(EditMonitorFooter, { disableSave: !form.isValid, monitor: monitor, onCancel: handleCancel, onDelete: (monitorConfig === null || monitorConfig === void 0 ? void 0 : monitorConfig.intrinsic) ?
                        undefined :
                        () => handleDelete(), onSave: handleSave })))));
};
